import { useTranslation } from "next-i18next";
import Button from "../UI/Button";
import BucketIcon from "../../public/img/mall/bucket.svg";
import { formatThousand } from "utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useIntersection } from "react-use";
import { useRef } from "react";
import classNames from "classnames";
import styled from "@emotion/styled";

const _MallHead = ({
  className = "",
  isLoggedIn,
  canClaimPoints,
  points,
  disableBtnFixed = false,
  myPointsClickEvent = "",
  ...rest
}) => {
  const { t: commonT } = useTranslation("common");
  const { t } = useTranslation("mall");
  const { locale } = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const intersectionRef = useRef();
  const intersection: any = useIntersection(intersectionRef, {
    root: null,
    rootMargin: "-100px 0px 0px",
    threshold: 1,
  });

  // console.log("intersection", intersection);

  let pointsText;
  if (isLoggedIn) {
    if (+points > 0) {
      pointsText = formatThousand(points);
    } else {
      pointsText = t("headBtnBrewing");
    }
  } else {
    pointsText = t("headBtnLogin");
  }

  return (
    <div className={classNames("flex items-center", className)} {...rest}>
      <div>
        <img src="/img/mall/head-img.png" className="img-points" alt="" />
      </div>

      <div className="right flex-1">
        <div className="title font-DIN_Alternate">{t("headTitle")}</div>

        <div className="flex items-center">
          <div ref={intersectionRef}></div>

          <div
            className={classNames("flex items-center cursor-pointer", {
              "fixed left-[80px] top-[124px] z-[1]":
                !disableBtnFixed && intersection?.intersectionRatio === 0,
            })}
            data-event={myPointsClickEvent}
            onClick={() => {
              if (!isLoggedIn) {
                const el: HTMLButtonElement = document.querySelector(
                  ".nav-btn-connect-wallet"
                );
                if (el) {
                  el.click();
                }
                return;
              }
              window.open(`/${locale}/points`);
            }}
          >
            <Button
              variant="contained"
              color="info"
              className={
                "h-[56px] pl-[12px] pr-[24px] rounded-full relative z-[1]"
              }
              startIcon={<BucketIcon />}
            >
              <div className="flex items-center text-[18px] font-medium leading-[20px] ml-[8px]">
                <div>My CUP Points</div>
                <div className="h-[20px] w-px bg-[rgba(0,0,0,0.4)] mx-[16px]"></div>
                <div className="font-black text-[20px]">{pointsText}</div>
              </div>
            </Button>

            {canClaimPoints && (
              <div className="flex items-center h-[56px] bg-[#B41E00] rounded-full text-[18px] pr-[32px] pl-[80px] relative z-0 ml-[-56px] group overflow-hidden">
                {t("headBtnClaim")}
                <div className="absolute left-0 top-0 w-full h-full bg-[rgba(0,0,0,.2)] opacity-0 transition group-hover:opacity-100"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MallHead = styled(_MallHead)`
  .img-points {
    width: 290px;
  }

  .right {
    margin-left: 60px;
  }

  .title {
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 0.015em;
    margin-bottom: 24px;
  }
`;

export const MallHeadForCollection = styled(_MallHead)`
  & {
    justify-content: center;
    padding-left: 60px;
    padding-right: 60px;
  }

  .img-points {
    width: 200px;
  }

  .right {
    margin-left: 40px;
  }

  .title {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 16px;
  }
`;
